(function () {
  'use strict';

  var ITEM_HEIGHT = 44;
  var FALLBACK_FREQUENCIES = [25, 30, 35, 40, 45, 50, 60, 70, 90, 120];
  var FREQUENCY_STORAGE_KEY = 'franklin_subscription_lp_frequency';
  var lockedFrequency = null;

  function getSectionEl() {
    return document.querySelector('[data-subscription-products]');
  }

  function getDiscountCode() {
    var section = getSectionEl();
    if (!section) return '';
    return (section.getAttribute('data-discount-code') || '').trim();
  }

  function readLockedFrequency() {
    try {
      var stored = sessionStorage.getItem(FREQUENCY_STORAGE_KEY);
      if (stored) {
        var n = Number(stored);
        if (!isNaN(n) && n > 0) return n;
      }
    } catch (e) {}
    return null;
  }

  function writeLockedFrequency(freq) {
    lockedFrequency = Number(freq);
    try {
      sessionStorage.setItem(FREQUENCY_STORAGE_KEY, String(lockedFrequency));
    } catch (e) {}
  }

  function clearLockedFrequency() {
    lockedFrequency = null;
    try {
      sessionStorage.removeItem(FREQUENCY_STORAGE_KEY);
    } catch (e) {}
  }

  function detectFrequencyFromCart(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var props = items[i].properties || {};
      if (props._shipping_interval_frequency) {
        var n = Number(props._shipping_interval_frequency);
        if (!isNaN(n) && n > 0) return n;
      }
    }
    return null;
  }

  function hasSubscriptionItems(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (item.selling_plan_allocation) return true;
      if (item.properties && item.properties._shipping_interval_frequency) return true;
    }
    return false;
  }

  function syncLockedFrequencyFromCart(cart) {
    if (!cart || !cart.item_count || !hasSubscriptionItems(cart)) {
      clearLockedFrequency();
      return null;
    }
    var fromCart = detectFrequencyFromCart(cart);
    if (fromCart) {
      writeLockedFrequency(fromCart);
      return fromCart;
    }
    return lockedFrequency;
  }

  function bindCartFrequencySync() {
    function onCart(cart) {
      if (cart) {
        syncLockedFrequencyFromCart(cart);
        return;
      }
      fetch('/cart.js')
        .then(function (r) {
          return r.json();
        })
        .then(syncLockedFrequencyFromCart)
        .catch(function () {});
    }

    if (window.jQuery) {
      jQuery(document).on('cart.requestComplete', function (event, cart) {
        onCart(cart);
      });
      jQuery(document).on('cart.requestDone', function () {
        onCart(null);
      });
    } else {
      document.addEventListener('cart:updated', function (e) {
        onCart(e && e.detail ? e.detail : null);
      });
    }
  }

  function applyDiscountCode() {
    var code = getDiscountCode();
    if (!code) return Promise.resolve();

    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var codes = cart.discount_codes || [];
        var alreadyApplied = codes.some(function (entry) {
          return entry && String(entry.code).toLowerCase() === code.toLowerCase();
        });
        if (alreadyApplied) return;

        return fetch('/discount/' + encodeURIComponent(code), {
          credentials: 'same-origin',
        }).catch(function (err) {
          console.warn('[subscription-products] discount apply failed', err);
        });
      })
      .catch(function (err) {
        console.warn('[subscription-products] discount check failed', err);
      });
  }

  function parseJsonAttr(el, attr, fallback) {
    try {
      var raw = el.getAttribute(attr);
      if (!raw) return fallback;
      return JSON.parse(raw);
    } catch (e) {
      return fallback;
    }
  }

  function formatMoney(value) {
    if (value == null || value === '') return '';
    var num = typeof value === 'number' ? value : parseFloat(String(value).replace(',', '.'));
    if (isNaN(num)) return String(value);
    return num.toFixed(2) + '€';
  }

  function labelForFrequency(n) {
    return n > 1 ? 'Tous les ' + n + ' jours' : 'Tous les ' + n + ' jour';
  }

  function formatPackLabel(option1) {
    if (!option1) return '';
    return String(option1)
      .replace(/^Lot de /i, '')
      .replace(/^À l'unité /i, '1 x ')
      .replace(/(\d)\s*[xX]\s*/g, '$1 x ')
      .replace(/2\.5kg/gi, '2.5 kg')
      .replace(/(\d+(?:[.,]\d+)?)\s*kg/gi, '$1 kg')
      .replace(/(\d+(?:[.,]\d+)?)\s*g\b/gi, '$1 g');
  }

  /* —— Frequency modal (wheel picker) —— */
  var FrequencyModal = {
    el: null,
    scrollEl: null,
    selected: 30,
    options: FALLBACK_FREQUENCIES.slice(),
    pending: null,
    scrollTimer: null,
    didInitialScroll: false,

    ensure: function () {
      if (this.el) return;
      var root = document.createElement('div');
      root.className = 'subscription-freq-modal';
      root.setAttribute('role', 'dialog');
      root.setAttribute('aria-modal', 'true');
      root.setAttribute('aria-labelledby', 'subscription-freq-modal-title');
      root.innerHTML =
        '<button type="button" class="subscription-freq-modal__backdrop" aria-label="Fermer"></button>' +
        '<div class="subscription-freq-modal__panel">' +
        '  <button type="button" class="subscription-freq-modal__close" aria-label="Fermer">×</button>' +
        '  <h2 id="subscription-freq-modal-title" class="subscription-freq-modal__title">Choisissez votre fréquence</h2>' +
        '  <div class="subscription-freq-modal__wheel-wrap">' +
        '    <div class="subscription-freq-wheel" role="listbox" aria-label="Fréquence de commande">' +
        '      <div class="subscription-freq-wheel__fade subscription-freq-wheel__fade--top" aria-hidden="true"></div>' +
        '      <div class="subscription-freq-wheel__fade subscription-freq-wheel__fade--bottom" aria-hidden="true"></div>' +
        '      <div class="subscription-freq-wheel__rail" aria-hidden="true"></div>' +
        '      <div class="subscription-freq-wheel__scroll"></div>' +
        '    </div>' +
        '  </div>' +
        '  <button type="button" class="subscription-freq-modal__confirm">JE VALIDE</button>' +
        '  <p class="subscription-freq-modal__footnote">Une seule fréquence possible pour tous vos produits en abonnement</p>' +
        '</div>';
      document.body.appendChild(root);
      this.el = root;
      this.scrollEl = root.querySelector('.subscription-freq-wheel__scroll');

      var self = this;
      root.querySelector('.subscription-freq-modal__backdrop').addEventListener('click', function () {
        self.close();
      });
      root.querySelector('.subscription-freq-modal__close').addEventListener('click', function () {
        self.close();
      });
      root.querySelector('.subscription-freq-modal__confirm').addEventListener('click', function () {
        self.confirm();
      });
      this.scrollEl.addEventListener('scroll', function () {
        if (self.scrollTimer) window.clearTimeout(self.scrollTimer);
        self.scrollTimer = window.setTimeout(function () {
          self.scrollTimer = null;
          self.syncFromScroll();
        }, 120);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });
    },

    renderOptions: function () {
      var self = this;
      this.scrollEl.innerHTML = '';
      this.options.forEach(function (n) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'subscription-freq-wheel__item' + (n === self.selected ? ' is-active' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', n === self.selected ? 'true' : 'false');
        btn.dataset.frequency = String(n);
        btn.textContent = labelForFrequency(n);
        btn.addEventListener('click', function () {
          self.setSelected(n, true);
        });
        self.scrollEl.appendChild(btn);
      });
    },

    setSelected: function (n, scroll) {
      this.selected = n;
      var items = this.scrollEl.querySelectorAll('.subscription-freq-wheel__item');
      for (var i = 0; i < items.length; i++) {
        var active = Number(items[i].dataset.frequency) === n;
        items[i].classList.toggle('is-active', active);
        items[i].setAttribute('aria-selected', active ? 'true' : 'false');
      }
      if (scroll) {
        var idx = this.options.indexOf(n);
        if (idx >= 0) {
          this.scrollEl.scrollTo({ top: idx * ITEM_HEIGHT, behavior: 'smooth' });
        }
      }
    },

    syncFromScroll: function () {
      if (!this.options.length) return;
      var idx = Math.round(this.scrollEl.scrollTop / ITEM_HEIGHT);
      idx = Math.max(0, Math.min(this.options.length - 1, idx));
      var next = this.options[idx];
      if (next !== undefined && next !== this.selected) {
        this.setSelected(next, false);
      }
    },

    open: function (options, defaultFreq, pending) {
      this.ensure();
      var sorted = (options && options.length ? options.slice() : FALLBACK_FREQUENCIES.slice())
        .map(Number)
        .filter(function (n) {
          return !isNaN(n) && n > 0;
        })
        .sort(function (a, b) {
          return a - b;
        });
      this.options = sorted.filter(function (n, i, arr) {
        return arr.indexOf(n) === i;
      });
      var preferred = Number(defaultFreq) || 30;
      if (this.options.indexOf(preferred) === -1) {
        preferred = this.options[Math.floor(this.options.length / 2)] || this.options[0];
      }
      this.selected = preferred;
      this.pending = pending;
      this.renderOptions();
      this.el.classList.add('is-open');
      document.body.classList.add('subscription-freq-modal-open');
      var self = this;
      requestAnimationFrame(function () {
        var idx = self.options.indexOf(self.selected);
        if (idx >= 0) self.scrollEl.scrollTop = idx * ITEM_HEIGHT;
      });
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.classList.remove('subscription-freq-modal-open');
      this.pending = null;
      var confirmBtn = this.el.querySelector('.subscription-freq-modal__confirm');
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'JE VALIDE';
      }
    },

    confirm: function () {
      if (!this.pending) return;
      var confirmBtn = this.el.querySelector('.subscription-freq-modal__confirm');
      if (confirmBtn) {
        confirmBtn.disabled = true;
        confirmBtn.textContent = '…';
      }
      var payload = Object.assign({}, this.pending, { frequency: this.selected });
      this.pending = null;
      writeLockedFrequency(this.selected);
      addSubscriptionItem(payload)
        .then(function () {
          FrequencyModal.close();
        })
        .catch(function (err) {
          console.error('[subscription-products] add failed', err);
          if (confirmBtn) {
            confirmBtn.disabled = false;
            confirmBtn.textContent = 'JE VALIDE';
          }
        });
    },
  };

  function resolveSellingPlanId(plans, frequency) {
    if (!plans || !plans.length) return null;
    for (var i = 0; i < plans.length; i++) {
      if (String(plans[i].frequency) === String(frequency)) {
        return plans[i].id;
      }
    }
    return plans[0] && plans[0].id ? plans[0].id : null;
  }

  function updateOtherSubscriptionsFrequency(newFrequency) {
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var chain = Promise.resolve();
        (cart.items || []).forEach(function (item, index) {
          if (!item.properties || !item.properties._shipping_interval_frequency) return;
          if (String(item.properties._shipping_interval_frequency) === String(newFrequency)) return;

          chain = chain.then(function () {
            return fetch('/products/' + item.handle + '.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (product) {
                var planId = null;
                var groups = product.selling_plan_groups || [];
                if (groups[0] && groups[0].selling_plans) {
                  var plans = groups[0].selling_plans.map(function (sp) {
                    var freq = String(sp.options && sp.options[0] ? sp.options[0].value : '')
                      .replace(' Day(s)', '')
                      .replace(' Week(s)', '')
                      .trim();
                    return { id: sp.id, frequency: freq };
                  });
                  planId = resolveSellingPlanId(plans, newFrequency);
                }

                var body = {
                  line: index + 1,
                  quantity: item.quantity,
                  properties: {
                    _shipping_interval_frequency: String(newFrequency),
                    _shipping_interval_unit_type: 'Days',
                  },
                };
                if (planId) body.selling_plan = planId;
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(body),
                });
              })
              .catch(function (err) {
                console.warn('[subscription-products] sync item failed', err);
              });
          });
        });
        return chain;
      })
      .catch(function (err) {
        console.warn('[subscription-products] could not sync frequencies', err);
      });
  }

  function addSubscriptionItem(payload) {
    var sellingPlanId = resolveSellingPlanId(payload.sellingPlans, payload.frequency);
    if (!sellingPlanId) {
      return Promise.reject(new Error('No selling plan for frequency ' + payload.frequency));
    }

    var items = [
      {
        id: Number(payload.variantId),
        quantity: Number(payload.quantity) || 1,
        selling_plan: sellingPlanId,
        properties: {
          _shipping_interval_frequency: String(payload.frequency),
          _shipping_interval_unit_type: 'Days',
        },
      },
    ];

    return updateOtherSubscriptionsFrequency(payload.frequency).then(function () {
      return new Promise(function (resolve, reject) {
        function afterAdd(data) {
          return applyDiscountCode()
            .then(function () {
              dispatchAnalytics(payload, data);
              if (typeof window.openCart === 'function') {
                window.openCart();
              }
              resolve(data);
            })
            .catch(function () {
              dispatchAnalytics(payload, data);
              if (typeof window.openCart === 'function') {
                window.openCart();
              }
              resolve(data);
            });
        }

        if (typeof CartJS === 'undefined' || !CartJS.addItems) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
          })
            .then(function (r) {
              if (!r.ok) throw new Error('cart/add failed');
              return r.json();
            })
            .then(afterAdd)
            .catch(reject);
          return;
        }

        CartJS.addItems(items, {
          success: function (data) {
            afterAdd(data);
          },
          error: function (jqXHR, textStatus, errorThrown) {
            reject(errorThrown || textStatus || new Error('CartJS error'));
          },
        });
      });
    });
  }

  function dispatchAnalytics(payload, data) {
    try {
      var detail = {
        sku: payload.sku || '',
        handle: payload.handle || '',
        quantity: Number(payload.quantity) || 1,
        subscription: true,
        inventory_status: 'subscription',
        creative: 'Subscription Collection Page',
        currency: 'EUR',
      };
      window.dispatchEvent(new CustomEvent('hb_add_to_cart', { detail: detail }));
    } catch (e) {}
  }

  /* —— Learn more modal (Figma / account add-flow) —— */
  var CHEVRON_SVG =
    '<svg class="subscription-learn-more__chevron" width="20" height="20" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
    '<path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  var CHECK_ICON =
    '<span class="subscription-learn-more__benefit-icon" aria-hidden="true"></span>';

  function LearnMoreModal() {
    this.el = null;
    this.scrollEl = null;
    this.images = [];
    this.imageIndex = 0;
    this.imageAnimating = false;
  }

  LearnMoreModal.prototype.ensure = function () {
    if (this.el) return this.el;

    var root = document.createElement('div');
    root.className = 'subscription-learn-more';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', 'subscription-learn-more-title');
    root.innerHTML =
      '<button type="button" class="subscription-learn-more__backdrop" aria-label="Fermer"></button>' +
      '<div class="subscription-learn-more__panel">' +
      '  <button type="button" class="subscription-learn-more__close" aria-label="Fermer">' +
      '    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
      '      <path d="M3 3L11 11M11 3L3 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '    </svg>' +
      '  </button>' +
      '  <h2 id="subscription-learn-more-title" class="subscription-learn-more__sr-only">En savoir plus</h2>' +
      '  <div class="subscription-learn-more__scroll" data-learn-more-scroll></div>' +
      '</div>';

    document.body.appendChild(root);
    this.el = root;
    this.scrollEl = root.querySelector('[data-learn-more-scroll]');

    var self = this;
    root.querySelector('.subscription-learn-more__backdrop').addEventListener('click', function () {
      self.close();
    });
    root.querySelector('.subscription-learn-more__close').addEventListener('click', function () {
      self.close();
    });
    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-learn-more-accordion]');
      if (!trigger || !root.contains(trigger)) return;
      var item = trigger.closest('.subscription-learn-more__accordion');
      if (!item) return;
      var panel = item.querySelector('.subscription-learn-more__accordion-panel');
      var chevron = item.querySelector('.subscription-learn-more__chevron');
      var open = trigger.getAttribute('aria-expanded') !== 'true';
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) {
        panel.hidden = !open;
        panel.classList.toggle('is-open', open);
      }
      if (chevron) chevron.classList.toggle('is-open', open);
    });

    root.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-lire-plus], [data-lire-moins]');
      if (!toggleBtn || !root.contains(toggleBtn)) return;
      var desc = toggleBtn.closest('[data-learn-more-desc]');
      if (!desc) return;
      var preview = desc.querySelector('[data-desc-preview]');
      var full = desc.querySelector('[data-desc-full]');
      var expand = toggleBtn.hasAttribute('data-lire-plus');
      if (preview) preview.hidden = !expand ? false : true;
      if (full) full.hidden = expand ? false : true;
    });

    root.addEventListener('click', function (e) {
      var prev = e.target.closest('[data-lm-prev]');
      var next = e.target.closest('[data-lm-next]');
      if (prev && root.contains(prev)) {
        e.preventDefault();
        self.setGalleryImage(self.imageIndex - 1);
        return;
      }
      if (next && root.contains(next)) {
        e.preventDefault();
        self.setGalleryImage(self.imageIndex + 1);
      }
    });

    return root;
  };

  function htmlToPlainText(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    var text = (tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim();
    return text.replace(/\s*\.{0,3}\s*Lire (plus|moins)\s*$/i, '').trim();
  }

  function stripTrailingEmptyHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    while (tmp.lastChild) {
      var node = tmp.lastChild;
      if (node.nodeType === 3 && !String(node.textContent || '').trim()) {
        tmp.removeChild(node);
        continue;
      }
      if (node.nodeType === 1) {
        var tag = node.tagName;
        var text = String(node.textContent || '').replace(/\u00a0/g, ' ').trim();
        if (tag === 'BR' || ((tag === 'P' || tag === 'DIV') && !text)) {
          tmp.removeChild(node);
          continue;
        }
      }
      break;
    }
    return tmp.innerHTML;
  }

  function buildDescriptionMarkup(html, modifier) {
    return (
      '<div class="subscription-learn-more__description subscription-learn-more__description--' +
      modifier +
      '" data-learn-more-desc>' +
      '<p class="subscription-learn-more__desc-preview" data-desc-preview>' +
      '<span data-desc-text></span>' +
      '<button type="button" class="subscription-learn-more__lire-plus" data-lire-plus>Lire plus</button>' +
      '</p>' +
      '<div class="subscription-learn-more__desc-full subscription-learn-more__rich" data-desc-full hidden>' +
      stripTrailingEmptyHtml(html) +
      '<button type="button" class="subscription-learn-more__lire-plus subscription-learn-more__lire-moins" data-lire-moins>Lire moins</button>' +
      '</div>' +
      '</div>'
    );
  }

  LearnMoreModal.prototype.setupDescriptionClamp = function (root) {
    var previewEl = root.querySelector('[data-desc-preview]');
    var textEl = root.querySelector('[data-desc-text]');
    var moreBtn = root.querySelector('[data-lire-plus]');
    var fullEl = root.querySelector('[data-desc-full]');
    if (!previewEl || !textEl || !moreBtn || !fullEl) return;

    // Skip invisible variant (desktop vs mobile) — measure only the visible one
    if (window.getComputedStyle(root).display === 'none') return;

    var plain = htmlToPlainText(fullEl.innerHTML);
    if (!plain) {
      previewEl.hidden = true;
      fullEl.hidden = false;
      return;
    }

    var styles = window.getComputedStyle(previewEl);
    var lineHeight = parseFloat(styles.lineHeight);
    if (!lineHeight || isNaN(lineHeight)) lineHeight = 17;
    var maxHeight = lineHeight * 3 + 0.5;

    moreBtn.hidden = true;
    textEl.textContent = plain;

    if (previewEl.scrollHeight <= maxHeight) {
      previewEl.hidden = true;
      fullEl.hidden = false;
      return;
    }

    moreBtn.hidden = false;
    var lo = 0;
    var hi = plain.length;
    var best = 0;

    while (lo <= hi) {
      var mid = (lo + hi) >> 1;
      textEl.textContent = plain.slice(0, mid).replace(/\s+$/, '') + '... ';
      if (previewEl.scrollHeight <= maxHeight) {
        best = mid;
        lo = mid + 1;
      } else {
        hi = mid - 1;
      }
    }

    var truncated = plain.slice(0, best).replace(/\s+$/, '');
    var lastSpace = truncated.lastIndexOf(' ');
    if (lastSpace > Math.floor(truncated.length * 0.55)) {
      truncated = truncated.slice(0, lastSpace);
    }
    textEl.textContent = truncated + '... ';
  };

  LearnMoreModal.prototype.bindDescriptions = function () {
    var nodes = this.scrollEl.querySelectorAll('[data-learn-more-desc]');
    for (var i = 0; i < nodes.length; i++) {
      this.setupDescriptionClamp(nodes[i]);
    }
  };

  LearnMoreModal.prototype.renderBody = function (data) {
    var vendor = (data && data.vendor) || '';
    var title = (data && data.title) || '';
    var descDesktop = (data && (data.descriptionDesktopHtml || data.descriptionMobileHtml)) || '';
    var descMobile = (data && (data.descriptionMobileHtml || data.descriptionDesktopHtml)) || '';
    var benefits = (data && data.benefits) || [];
    var details = (data && data.details) || [];
    var images = (data && data.images) || [];
    if (!images.length && data && data.image) images = [data.image];
    this.images = images;
    this.imageIndex = 0;
    this.imageAnimating = false;

    var html = '';
    var alt = escapeHtml(toSentenceCase(vendor || title || ''));
    var firstSrc = images.length ? escapeHtml(images[0]) : '';

    html +=
      '<div class="subscription-learn-more__media">' +
      '<div class="subscription-learn-more__gallery" data-lm-gallery>' +
      '<img class="subscription-learn-more__image is-active" data-lm-image src="' +
      firstSrc +
      '" alt="' +
      alt +
      '">' +
      '<img class="subscription-learn-more__image" data-lm-image-next alt="" aria-hidden="true">' +
      '</div>' +
      '<button type="button" class="subscription-learn-more__nav subscription-learn-more__nav--prev" data-lm-prev aria-label="Image précédente"' +
      (images.length > 1 ? '' : ' hidden') +
      '>' +
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</button>' +
      '<button type="button" class="subscription-learn-more__nav subscription-learn-more__nav--next" data-lm-next aria-label="Image suivante"' +
      (images.length > 1 ? '' : ' hidden') +
      '>' +
      '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M9 6L15 12L9 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</button>' +
      '</div>';

    html += '<div class="subscription-learn-more__body">';

    if (vendor) {
      html += '<p class="subscription-learn-more__vendor">' + escapeHtml(toSentenceCase(vendor)) + '</p>';
    }
    if (title) {
      html +=
        '<p class="subscription-learn-more__product-title">' +
        escapeHtml(toSentenceCase(title)) +
        '</p>';
    }
    if (descDesktop) {
      html += buildDescriptionMarkup(descDesktop, 'desktop');
    }
    if (descMobile) {
      html += buildDescriptionMarkup(descMobile, 'mobile');
    }

    if (benefits.length || details.length) {
      html += '<div class="subscription-learn-more__sections">';

      if (benefits.length) {
        html += '<div class="subscription-learn-more__benefits">';
        html += '<p class="subscription-learn-more__benefits-title">Bénéfices</p>';
        html += '<ul class="subscription-learn-more__benefits-list">';
        for (var b = 0; b < benefits.length; b++) {
          html +=
            '<li>' +
            CHECK_ICON +
            '<span>' +
            escapeHtml(toSentenceCase(String(benefits[b] || ''))) +
            '</span></li>';
        }
        html += '</ul></div>';
      }

      for (var d = 0; d < details.length; d++) {
        var entry = details[d] || {};
        var panelId = 'subscription-learn-more-' + (entry.id || d);
        html +=
          '<div class="subscription-learn-more__accordion">' +
          '<button type="button" class="subscription-learn-more__accordion-trigger" data-learn-more-accordion aria-expanded="true" aria-controls="' +
          panelId +
          '">' +
          '<span>' +
          escapeHtml(toSentenceCase(String(entry.title || ''))) +
          '</span>' +
          CHEVRON_SVG +
          '</button>' +
          '<div id="' +
          panelId +
          '" class="subscription-learn-more__accordion-panel is-open">' +
          '<div class="subscription-learn-more__accordion-content subscription-learn-more__rich">' +
          stripTrailingEmptyHtml(entry.html || '') +
          '</div></div></div>';
      }

      html += '</div>';
    }

    html += '</div>';

    if (!vendor && !title && !descDesktop && !descMobile && !benefits.length && !details.length && !images.length) {
      html =
        '<div class="subscription-learn-more__body"><p class="subscription-learn-more__empty">Informations indisponibles pour ce produit.</p></div>';
    }

    this.scrollEl.innerHTML = html;

    var chevrons = this.scrollEl.querySelectorAll('.subscription-learn-more__chevron');
    for (var c = 0; c < chevrons.length; c++) {
      chevrons[c].classList.add('is-open');
    }

    this.bindGallerySwipe();

    var self = this;
    requestAnimationFrame(function () {
      self.bindDescriptions();
    });
  };

  LearnMoreModal.prototype.bindGallerySwipe = function () {
    var surface = this.scrollEl.querySelector('[data-lm-gallery]');
    if (!surface) return;
    var self = this;
    var startX = 0;
    var startY = 0;
    var tracking = false;

    surface.addEventListener(
      'touchstart',
      function (e) {
        if (!self.images || self.images.length < 2) return;
        if (!e.touches || !e.touches.length) return;
        tracking = true;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
      },
      { passive: true }
    );

    surface.addEventListener(
      'touchend',
      function (e) {
        if (!tracking) return;
        tracking = false;
        if (!e.changedTouches || !e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0) self.setGalleryImage(self.imageIndex + 1);
        else self.setGalleryImage(self.imageIndex - 1);
      },
      { passive: true }
    );
  };

  LearnMoreModal.prototype.setGalleryImage = function (index, instant) {
    if (!this.images || !this.images.length) return;
    var imageEl = this.scrollEl.querySelector('[data-lm-image]');
    var nextEl = this.scrollEl.querySelector('[data-lm-image-next]');
    if (!imageEl) return;

    var nextIndex = ((index % this.images.length) + this.images.length) % this.images.length;
    var nextSrc = this.images[nextIndex];

    if (nextIndex === this.imageIndex && imageEl.getAttribute('src')) return;

    if (instant || !nextEl || this.images.length < 2) {
      this.imageIndex = nextIndex;
      this.imageAnimating = false;
      imageEl.src = nextSrc;
      imageEl.classList.add('is-active');
      if (nextEl) {
        nextEl.classList.remove('is-active');
        nextEl.removeAttribute('src');
      }
      return;
    }

    this.imageIndex = nextIndex;
    this.imageAnimating = true;
    var incoming = imageEl.classList.contains('is-active') ? nextEl : imageEl;
    var outgoing = incoming === imageEl ? nextEl : imageEl;
    var self = this;

    incoming.src = nextSrc;

    var startFade = function () {
      incoming.classList.add('is-active');
      outgoing.classList.remove('is-active');
      window.setTimeout(function () {
        self.imageAnimating = false;
      }, 360);
    };

    if (incoming.complete) {
      startFade();
    } else {
      incoming.onload = function () {
        incoming.onload = null;
        startFade();
      };
    }
  };

  LearnMoreModal.prototype.lockScroll = function () {
    if (this._scrollLocked) return;
    this._scrollLocked = true;
    this._prevBodyOverflow = document.body.style.overflow;
    this._prevHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.classList.add('subscription-learn-more-open');
    document.body.classList.add('subscription-learn-more-open');
  };

  LearnMoreModal.prototype.unlockScroll = function () {
    if (!this._scrollLocked) return;
    this._scrollLocked = false;
    document.documentElement.classList.remove('subscription-learn-more-open');
    document.body.classList.remove('subscription-learn-more-open');
    document.body.style.overflow = this._prevBodyOverflow || '';
    document.documentElement.style.overflow = this._prevHtmlOverflow || '';
    this._prevBodyOverflow = '';
    this._prevHtmlOverflow = '';
  };

  LearnMoreModal.prototype.open = function (data) {
    this.ensure();
    this.renderBody(data || {});
    this.lockScroll();
    this.el.classList.add('is-open');
  };

  LearnMoreModal.prototype.close = function () {
    if (!this.el) return;
    if (document.activeElement && this.el.contains(document.activeElement)) {
      document.activeElement.blur();
    }
    this.el.classList.remove('is-open');
    this.unlockScroll();
  };

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function toSentenceCase(str) {
    var s = String(str || '')
      .replace(/\s+/g, ' ')
      .trim();
    if (!s) return '';

    // First letter of the phrase always uppercase.
    // Other words: keep capital only if original already started uppercase.
    var parts = s.split(/(\s+|\/)/);
    var out = '';
    var isFirstWord = true;

    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (!part) continue;
      if (/^\s+$/.test(part) || part === '/') {
        out += part;
        continue;
      }

      var startsUpper = /^[A-ZÀÂÄÆÇÉÈÊËÏÎÔŒÙÛÜŸ]/.test(part.charAt(0));
      var lower = part.toLowerCase();
      if (isFirstWord || startsUpper) {
        out += lower.charAt(0).toUpperCase() + lower.slice(1);
      } else {
        out += lower;
      }
      isFirstWord = false;
    }

    return out;
  }

  function dispatchFeedingGuideAction(detail) {
    try {
      window.dispatchEvent(new CustomEvent('hb_feeding_guide_action', { detail: detail || {} }));
    } catch (e) {}
  }

  function dispatchNavigationClick(detail) {
    try {
      window.dispatchEvent(new CustomEvent('hb_navigation_click', { detail: detail || {} }));
    } catch (e) {}
  }

  var learnMoreModal = new LearnMoreModal();

  /* —— Ration finder modal —— */
  function parseKgFromOption(option1) {
    if (!option1) return null;
    var m = String(option1).replace(',', '.').match(/(\d+(?:\.\d+)?)\s*kg/i);
    if (m) return parseFloat(m[1]);
    var g = String(option1).replace(',', '.').match(/(\d+(?:\.\d+)?)\s*g\b/i);
    if (g) return parseFloat(g[1]) / 1000;
    return null;
  }

  function formatKgLabel(kg) {
    if (kg == null || isNaN(kg)) return '';
    var n = Number(kg);
    if (Math.abs(n - Math.round(n)) < 0.05) return String(Math.round(n));
    return String(n).replace('.', ',');
  }

  function parseDailyGrams(rationRaw, isMixed) {
    var raw = String(rationRaw || '');
    if (isMixed || /\+/.test(raw)) {
      // "50g croquettes + 100g pâtée" → use croquettes portion only
      var first = raw.match(/(\d+(?:[.,]\d+)?)\s*g/i);
      if (first) return parseFloat(String(first[1]).replace(',', '.')) || 0;
    }
    var grams = parseInt(raw.replace(/[^\d]/g, ''), 10);
    return isNaN(grams) ? 0 : grams;
  }

  function isMixedAnswer(answers) {
    for (var i = 0; i < answers.length; i++) {
      var a = String(answers[i] || '').toLowerCase();
      if (a === 'mixte' || a.indexOf('mixte') !== -1) return true;
    }
    return false;
  }

  function matchRationResult(results, answers) {
    if (!results || !results.length) return null;
    for (var i = 0; i < results.length; i++) {
      var row = results[i];
      var ok = true;
      for (var a = 0; a < answers.length; a++) {
        var key = 'answer_' + (a + 1);
        if (row[key] == null || row[key] === '') continue;
        if (String(row[key]).trim() !== String(answers[a]).trim()) {
          ok = false;
          break;
        }
      }
      if (ok && row.result != null && row.result !== '') return row;
    }
    return null;
  }

  function recommendPack(variants, monthlyKg) {
    if (!variants || !variants.length || !monthlyKg) return null;
    var best = null;
    var bestDiff = Infinity;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (!v.available) continue;
      var kg = parseKgFromOption(v.option1);
      if (!kg || kg <= 0) continue;
      var bags = monthlyKg / kg;
      var diff = Math.abs(bags - 1);
      if (diff < bestDiff) {
        bestDiff = diff;
        best = { variant: v, kg: kg, bags: bags };
      }
    }
    return best;
  }

  function RationModal() {
    this.el = null;
    this.card = null;
    this.results = [];
    this.questions = [];
    this.imageSrc = '';
  }

  RationModal.prototype.ensure = function () {
    if (this.el && document.body.contains(this.el)) return;
    var orphans = document.querySelectorAll('.subscription-ration');
    for (var oi = 0; oi < orphans.length; oi++) {
      if (orphans[oi].parentNode) orphans[oi].parentNode.removeChild(orphans[oi]);
    }
    this.el = null;
    var root = document.createElement('div');
    root.className = 'subscription-ration';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.innerHTML =
      '<div class="subscription-ration__backdrop" data-ration-backdrop></div>' +
      '<div class="subscription-ration__panel">' +
      '<button type="button" class="subscription-ration__close" data-ration-close aria-label="Fermer">×</button>' +
      '<div class="subscription-ration__header">' +
      '<h2 class="subscription-ration__title">Je calcule<br>sa ration journalière</h2>' +
      '<p class="subscription-ration__vendor" data-ration-vendor></p>' +
      '<p class="subscription-ration__product" data-ration-product></p>' +
      '</div>' +
      '<hr class="subscription-ration__divider">' +
      '<p class="subscription-ration__loading" data-ration-loading>Chargement…</p>' +
      '<p class="subscription-ration__empty" data-ration-empty>Calculateur indisponible pour ce produit.</p>' +
      '<div class="subscription-ration__form" data-ration-form></div>' +
      '<div class="subscription-ration__result" data-ration-result>' +
      '<p class="subscription-ration__result-title">Sa ration idéale</p>' +
      '<p class="subscription-ration__result-text" data-ration-result-text></p>' +
      '<div class="subscription-ration__result-row">' +
      '<img class="subscription-ration__result-image" data-ration-result-image alt="" width="110" height="110">' +
      '<p class="subscription-ration__result-pack" data-ration-result-pack></p>' +
      '</div>' +
      '<button type="button" class="subscription-ration__atc" data-ration-atc>JE M\'ABONNE</button>' +
      '</div>' +
      '</div>';
    document.body.appendChild(root);
    this.el = root;
    this.vendorEl = root.querySelector('[data-ration-vendor]');
    this.productEl = root.querySelector('[data-ration-product]');
    this.loadingEl = root.querySelector('[data-ration-loading]');
    this.emptyEl = root.querySelector('[data-ration-empty]');
    this.formEl = root.querySelector('[data-ration-form]');
    this.resultEl = root.querySelector('[data-ration-result]');
    this.resultTextEl = root.querySelector('[data-ration-result-text]');
    this.resultImageEl = root.querySelector('[data-ration-result-image]');
    this.resultPackEl = root.querySelector('[data-ration-result-pack]');
    this.atcEl = root.querySelector('[data-ration-atc]');

    var self = this;
    root.querySelector('[data-ration-backdrop]').addEventListener('click', function () {
      self.close();
    });
    root.querySelector('[data-ration-close]').addEventListener('click', function () {
      self.close();
    });
    this.atcEl.addEventListener('click', function () {
      self.confirmAdd();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && self.el && self.el.classList.contains('is-open')) self.close();
    });
  };

  RationModal.prototype.open = function (cardController) {
    this.ensure();
    this.card = cardController;
    var card = cardController.card;
    var handle = card.getAttribute('data-product-handle');
    var title = card.getAttribute('data-product-name') || '';
    var vendor = card.getAttribute('data-product-vendor') || '';
    this.imageSrc = card.getAttribute('data-product-image') || '';
    this.vendorEl.textContent = vendor ? toSentenceCase(vendor) : '';
    this.vendorEl.hidden = !vendor;
    this.productEl.textContent = title ? toSentenceCase(title) : '';

    var cardAtc = card.querySelector('[data-sub-atc]');
    if (this.atcEl && cardAtc) {
      // Exclude tooltip ("Veuillez sélectionner…") nested inside the ATC button
      var atcClone = cardAtc.cloneNode(true);
      var tip = atcClone.querySelector('[data-sub-tooltip]');
      if (tip) tip.remove();
      var atcLabel = (atcClone.textContent || '').replace(/\s+/g, ' ').trim();
      if (atcLabel) this.atcEl.textContent = atcLabel;
    }

    this.formEl.innerHTML = '';
    this.resultEl.classList.remove('is-visible');
    this.emptyEl.classList.remove('is-visible');
    this.loadingEl.classList.add('is-visible');
    this.recommendedVariantId = null;
    this.recommendationSummary = null;
    this.el.classList.add('is-open');
    document.body.classList.add('subscription-ration-open');

    dispatchFeedingGuideAction({
      type: 'click',
      name: 'feeding_guide_action',
      creative: 'Subscription Collection Page',
      handle: handle || '',
    });

    var self = this;
    fetch('/products/' + encodeURIComponent(handle) + '?section_id=calculateur-de-ration')
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var box = doc.querySelector('.calculateur-de-ration__first-questions-box');
        if (!box) {
          self.loadingEl.classList.remove('is-visible');
          self.emptyEl.classList.add('is-visible');
          return;
        }
        try {
          self.results = JSON.parse(box.getAttribute('data-calculateur-results') || '[]');
        } catch (e) {
          self.results = [];
        }
        var img = doc.querySelector('.calculateur-de-ration__image');
        if (img && img.getAttribute('src')) self.imageSrc = img.getAttribute('src');

        var questionBoxes = box.querySelectorAll('.calculateur-de-ration__question-box');
        self.questions = [];
        self.formEl.innerHTML = '';
        for (var i = 0; i < questionBoxes.length; i++) {
          var qBox = questionBoxes[i];
          var label = qBox.querySelector('label');
          var select = qBox.querySelector('select');
          if (!label || !select) continue;
          var field = document.createElement('div');
          field.className = 'subscription-ration__field';
          var lab = document.createElement('p');
          lab.className = 'subscription-ration__label';
          lab.textContent = toSentenceCase(label.textContent.trim());
          var sel = document.createElement('select');
          sel.className = 'subscription-ration__select';
          sel.dataset.questionIndex = String(i);
          var sourceOptions = select.querySelectorAll('option');
          for (var o = 0; o < sourceOptions.length; o++) {
            var srcOpt = sourceOptions[o];
            var opt = document.createElement('option');
            opt.value = srcOpt.value;
            opt.textContent = toSentenceCase(srcOpt.textContent.trim());
            if (srcOpt.selected) opt.selected = true;
            if (srcOpt.disabled) opt.disabled = true;
            sel.appendChild(opt);
          }
          field.appendChild(lab);
          field.appendChild(sel);
          self.formEl.appendChild(field);
          self.questions.push(sel);
          sel.addEventListener('change', function () {
            self.recalculate();
          });
        }

        self.loadingEl.classList.remove('is-visible');
        if (!self.questions.length) {
          self.emptyEl.classList.add('is-visible');
        }
      })
      .catch(function () {
        self.loadingEl.classList.remove('is-visible');
        self.emptyEl.classList.add('is-visible');
      });
  };

  RationModal.prototype.recalculate = function () {
    var answers = [];
    var complete = true;
    for (var i = 0; i < this.questions.length; i++) {
      var val = this.questions[i].value;
      if (!val) {
        complete = false;
        break;
      }
      answers.push(val);
    }
    if (!complete) {
      this.resultEl.classList.remove('is-visible');
      this.recommendedVariantId = null;
      this.recommendationSummary = null;
      return;
    }

    var match = matchRationResult(this.results, answers);
    if (!match || !match.result) {
      this.resultEl.classList.remove('is-visible');
      this.recommendedVariantId = null;
      this.recommendationSummary = null;
      return;
    }

    var rationRaw = String(match.result);
    var mixed = isMixedAnswer(answers) || /\+/.test(rationRaw);
    var grams = parseDailyGrams(rationRaw, mixed);
    var monthlyKg = (grams * 31) / 1000;
    var monthlyLabel = formatKgLabel(Number(monthlyKg.toFixed(1)));
    if (String(monthlyLabel).slice(-2) === ',0') monthlyLabel = String(monthlyLabel).slice(0, -2);

    var rationLabel = rationRaw.replace(/\s*\/?jour\.?$/i, '');
    if (mixed) {
      // Match PDP: mixed food shows daily ration only (no inflated kg/mois)
      this.resultTextEl.textContent = rationLabel + '/jour.';
      this.recommendationSummary = {
        prefix: 'Ration recommandée : ',
        value: rationLabel + ' / jour',
      };
    } else {
      this.resultTextEl.textContent =
        rationLabel + '/jour, soit une consommation de ' + monthlyLabel + ' kg/mois';
      this.recommendationSummary = {
        prefix: 'Ration recommandée : ',
        value: monthlyLabel + ' kg / mois',
      };
    }

    var pack = !mixed || grams > 0 ? recommendPack(this.card.variants, monthlyKg) : null;
    if (mixed && grams <= 0) pack = null;

    if (pack) {
      this.recommendedVariantId = pack.variant.id;
      var bagsRounded = Math.max(1, Math.round(pack.bags));
      var packLabel = formatKgLabel(pack.kg).replace('.', ',');
      if (this.resultPackEl) {
        this.resultPackEl.innerHTML =
          '= environ ' +
          bagsRounded +
          ' sac' +
          (bagsRounded > 1 ? 's' : '') +
          ' de<br>' +
          packLabel +
          ' kg par mois';
      }
    } else {
      this.recommendedVariantId = null;
      if (this.resultPackEl) this.resultPackEl.textContent = '';
    }

    if (this.resultImageEl) {
      this.resultImageEl.src = this.imageSrc || '';
      this.resultImageEl.alt = (this.productEl && this.productEl.textContent) || '';
    }
    if (this.resultEl) this.resultEl.classList.add('is-visible');

    var self = this;
    window.requestAnimationFrame(function () {
      if (self.resultEl && typeof self.resultEl.scrollIntoView === 'function') {
        self.resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });

    dispatchFeedingGuideAction({
      type: 'generate',
      name: 'feeding_guide_action',
      result: rationRaw,
      creative: 'Subscription Collection Page',
    });
  };

  RationModal.prototype.applyRecommendationToCard = function () {
    if (!this.card) return;
    if (this.recommendedVariantId) {
      var variant = null;
      for (var i = 0; i < this.card.variants.length; i++) {
        if (String(this.card.variants[i].id) === String(this.recommendedVariantId)) {
          variant = this.card.variants[i];
          break;
        }
      }
      if (variant) {
        if (variant.option2) {
          this.card.selectedTaille = variant.option2;
          this.card.renderTaille();
        }
        this.card.renderPacks();
        this.card.selectVariant(variant.id);
      }
    }
    if (this.recommendationSummary) {
      this.card.setRationSummary(this.recommendationSummary);
    }
  };

  RationModal.prototype.confirmAdd = function () {
    if (!this.card) return;
    this.applyRecommendationToCard();
    dispatchNavigationClick({
      name: 'add_to_cart',
      creative: 'Subscription Collection Page — Daily Calculator',
      handle: this.card.card.getAttribute('data-product-handle') || '',
    });
    this.close({ skipApply: true });
    this.card.handleAdd();
  };

  RationModal.prototype.close = function (opts) {
    if (!this.el) return;
    if (!(opts && opts.skipApply)) {
      this.applyRecommendationToCard();
    }
    this.el.classList.remove('is-open');
    document.body.classList.remove('subscription-ration-open');
  };

  var rationModal = new RationModal();

  /* —— Product card controller —— */
  function readJsonScript(card, selector, fallback) {
    var node = card.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return fallback;
    }
  }

  function SubscriptionProductCard(card) {
    this.card = card;
    this.variants = readJsonScript(card, '[data-sub-variants-json]', []);
    this.sellingPlans = parseJsonAttr(card, 'data-abonnement-product-selling-plans', {}).sellings_plan || [];
    this.hasTaille = card.getAttribute('data-has-taille') === 'true';
    this.quantity = 1;
    this.selectedTaille = null;
    this.selectedVariantId = null;
    this.maxByVariant = readJsonScript(card, '[data-sub-maximum-json]', {});
    this.images = readJsonScript(card, '[data-sub-images-json]', []);
    this.rationSummary = null;
    this.rationDefaultLabel = 'Je calcule sa ration journalière';

    this.qtyEl = card.querySelector('[data-sub-qty]');
    this.packsEl = card.querySelector('[data-sub-packs]');
    this.tailleEl = card.querySelector('[data-sub-taille]');
    this.atcBtn = card.querySelector('[data-sub-atc]');
    this.tooltip = card.querySelector('[data-sub-tooltip]');
    this.rationBtn = card.querySelector('[data-sub-ration]');
    if (this.rationBtn) {
      this.rationDefaultLabel = this.rationBtn.textContent.trim() || this.rationDefaultLabel;
    }

    if (!this.images || !this.images.length) {
      var fallback = card.getAttribute('data-product-image');
      this.images = fallback ? [fallback] : [];
    }

    this.init();
  }

  SubscriptionProductCard.prototype.init = function () {
    var self = this;

    if (this.hasTaille && this.tailleEl) {
      var tailleBtns = this.tailleEl.querySelectorAll('[data-taille]');
      var preferred = null;
      for (var i = 0; i < tailleBtns.length; i++) {
        var t = tailleBtns[i].getAttribute('data-taille');
        if (/normale/i.test(t)) preferred = t;
      }
      if (!preferred && tailleBtns.length) preferred = tailleBtns[0].getAttribute('data-taille');
      this.selectedTaille = preferred;
      this.renderTaille();
      this.tailleEl.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-taille]');
        if (!btn) return;
        self.selectedTaille = btn.getAttribute('data-taille');
        self.renderTaille();
        self.renderPacks();
      });
    }

    this.renderPacks();

    var minusBtn = this.card.querySelector('[data-sub-minus]');
    var plusBtn = this.card.querySelector('[data-sub-plus]');
    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        self.setQuantity(self.quantity - 1);
      });
    }
    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        self.setQuantity(self.quantity + 1);
      });
    }

    if (this.atcBtn) {
      this.atcBtn.addEventListener('click', function () {
        dispatchNavigationClick({
          name: 'add_to_cart',
          creative: 'Subscription Collection Page',
          handle: self.card.getAttribute('data-product-handle') || '',
        });
        self.handleAdd();
      });
    }

    var learnMoreBtn = this.card.querySelector('[data-sub-learn-more]');
    if (learnMoreBtn) {
      learnMoreBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self.openLearnMore('en_savoir_plus');
      });
    }

    var mediaEl = this.card.querySelector('[data-sub-open-learn-more]');
    if (mediaEl) {
      mediaEl.addEventListener('click', function (e) {
        if (e.target.closest('[data-sub-learn-more]')) return;
        e.preventDefault();
        self.openLearnMore('product_visual');
      });
    }

    if (this.rationBtn) {
      this.rationBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        rationModal.open(self);
      });
    }
  };

  SubscriptionProductCard.prototype.openLearnMore = function (source) {
    var data = readJsonScript(this.card, '[data-sub-learn-more-json]', null);
    if (!data) {
      data = {
        title: this.card.getAttribute('data-product-name') || '',
        vendor: this.card.getAttribute('data-product-vendor') || '',
        benefits: [],
        details: [],
      };
    }
    data.images = this.images || [];
    if (!data.images.length) {
      var fallback = this.card.getAttribute('data-product-image');
      data.images = fallback ? [fallback] : [];
    }

    dispatchNavigationClick({
      name: source === 'product_visual' ? 'product_visual' : 'en_savoir_plus',
      creative:
        source === 'product_visual'
          ? 'Subscription Collection Page — Product Visual'
          : 'Subscription Collection Page — En savoir +',
      handle: this.card.getAttribute('data-product-handle') || '',
      click_text: source === 'product_visual' ? 'product_visual' : 'En savoir +',
    });

    learnMoreModal.open(data);
  };

  SubscriptionProductCard.prototype.setRationSummary = function (summary) {
    this.rationSummary = summary || null;
    if (!this.rationBtn) return;
    if (!summary) {
      this.rationBtn.textContent = this.rationDefaultLabel;
      return;
    }
    var prefix = typeof summary === 'string' ? '' : summary.prefix || '';
    var value = typeof summary === 'string' ? summary : summary.value || '';
    this.rationBtn.innerHTML =
      escapeHtml(prefix) +
      '<span class="subscription-product__calculator-value">' +
      escapeHtml(value) +
      '</span>';
  };

  SubscriptionProductCard.prototype.setQuantity = function (n) {
    var max = 25;
    if (this.selectedVariantId && this.maxByVariant[this.selectedVariantId] != null) {
      max = Number(this.maxByVariant[this.selectedVariantId]) || 25;
    }
    this.quantity = Math.max(1, Math.min(max, n));
    if (this.qtyEl) this.qtyEl.textContent = String(this.quantity);
  };

  SubscriptionProductCard.prototype.renderTaille = function () {
    if (!this.tailleEl) return;
    var btns = this.tailleEl.querySelectorAll('[data-taille]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].classList.toggle('is-selected', btns[i].getAttribute('data-taille') === this.selectedTaille);
    }
  };

  SubscriptionProductCard.prototype.filteredVariants = function () {
    var self = this;
    return this.variants.filter(function (v) {
      if (String(v.title || '').indexOf('Échantillons') !== -1) return false;
      if (self.hasTaille && self.selectedTaille) {
        return String(v.option2 || '') === String(self.selectedTaille);
      }
      return true;
    });
  };

  SubscriptionProductCard.prototype.renderPacks = function () {
    if (!this.packsEl) return;
    var variants = this.filteredVariants();
    this.packsEl.innerHTML = '';
    var self = this;
    var firstAvailable = null;

    variants.forEach(function (v) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'subscription-product__pack';
      btn.dataset.variantId = String(v.id);
      if (!v.available) btn.classList.add('is-disabled');
      else if (!firstAvailable) firstAvailable = v;

      var compareHtml = '';
      if (v.compare_at_price && Number(v.compare_at_price) > Number(v.subscription_price)) {
        compareHtml =
          '<span class="subscription-product__pack-compare">' +
          formatMoney(v.compare_at_price / 100) +
          '</span>';
      } else if (v.price && Number(v.price) > Number(v.subscription_price)) {
        compareHtml =
          '<span class="subscription-product__pack-compare">' + formatMoney(v.price / 100) + '</span>';
      }

      btn.innerHTML =
        '<span class="subscription-product__pack-label">' +
        formatPackLabel(v.option1) +
        '</span>' +
        '<span class="subscription-product__pack-price">' +
        formatMoney(v.subscription_price / 100) +
        '</span>' +
        compareHtml;

      btn.addEventListener('click', function () {
        if (!v.available) return;
        self.selectVariant(v.id);
      });
      self.packsEl.appendChild(btn);
    });

    if (firstAvailable) {
      this.selectVariant(firstAvailable.id);
    } else {
      this.selectedVariantId = null;
    }
  };

  SubscriptionProductCard.prototype.selectVariant = function (id) {
    this.selectedVariantId = Number(id);
    var packs = this.packsEl.querySelectorAll('.subscription-product__pack');
    for (var i = 0; i < packs.length; i++) {
      packs[i].classList.toggle('is-selected', Number(packs[i].dataset.variantId) === this.selectedVariantId);
    }
    this.setQuantity(this.quantity);
  };

  SubscriptionProductCard.prototype.showTooltip = function () {
    if (!this.tooltip) return;
    this.tooltip.classList.add('is-visible');
    var tip = this.tooltip;
    window.clearTimeout(this._tooltipTimer);
    this._tooltipTimer = window.setTimeout(function () {
      tip.classList.remove('is-visible');
    }, 2200);
  };

  SubscriptionProductCard.prototype.handleAdd = function () {
    if (!this.selectedVariantId) {
      this.showTooltip();
      return;
    }
    var variant = null;
    for (var i = 0; i < this.variants.length; i++) {
      if (Number(this.variants[i].id) === Number(this.selectedVariantId)) {
        variant = this.variants[i];
        break;
      }
    }
    if (!variant || !variant.available) {
      this.showTooltip();
      return;
    }

    var payload = {
      variantId: variant.id,
      quantity: this.quantity,
      sellingPlans: this.sellingPlans,
      sku: variant.sku || '',
      handle: this.card.getAttribute('data-product-handle') || '',
      productId: this.card.getAttribute('data-product-id') || '',
      productName: this.card.getAttribute('data-product-name') || '',
    };

    // Same frequency for all subscription products: skip modal after first choice
    if (lockedFrequency) {
      if (this.atcBtn) this.atcBtn.classList.add('is-loading');
      var self = this;
      addSubscriptionItem(Object.assign({}, payload, { frequency: lockedFrequency }))
        .catch(function (err) {
          console.error('[subscription-products] add failed', err);
        })
        .finally(function () {
          if (self.atcBtn) self.atcBtn.classList.remove('is-loading');
        });
      return;
    }

    var freqs = this.sellingPlans
      .map(function (p) {
        return Number(p.frequency);
      })
      .filter(function (n) {
        return !isNaN(n);
      });

    var section = this.card.closest('[data-subscription-products]');
    var defaultFreq = 30;
    if (section && section.getAttribute('data-default-frequency')) {
      defaultFreq = section.getAttribute('data-default-frequency');
    }

    FrequencyModal.open(freqs.length ? freqs : FALLBACK_FREQUENCIES, defaultFreq, payload);
  };

  function initLockedFrequency() {
    lockedFrequency = readLockedFrequency();
    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        syncLockedFrequencyFromCart(cart);
      })
      .catch(function () {});
  }

  function getActiveFilterTags() {
    var animalInput = document.querySelector('input[name="animal-tags"]:checked');
    if (!animalInput) {
      return { animal: [], type: [] };
    }

    var tagAnimalArray = animalInput.value.split(',');
    var tagTypeArray = [];
    var typeTagInputs = document.querySelectorAll('input.type-tag');
    var allProducts = document.querySelectorAll('.abonnement-product');
    var availableTypeTagInputs = [];

    for (var t = 0; t < typeTagInputs.length; t++) {
      var typeInput = typeTagInputs[t];
      var currentTypeTags = typeInput.value.split(',');
      var hasMatchForCategory = false;

      for (var j = 0; j < allProducts.length; j++) {
        var categoryProductTags = (allProducts[j].getAttribute('data-abonnement-product-tag') || '').split(',');
        var matchesAnimal = categoryProductTags.some(function (r) {
          return tagAnimalArray.indexOf(r) !== -1;
        });
        var matchesType = categoryProductTags.some(function (r) {
          return currentTypeTags.indexOf(r) !== -1;
        });
        if (matchesAnimal && matchesType) {
          hasMatchForCategory = true;
          break;
        }
      }

      var categoryLabel = typeInput.nextElementSibling;
      if (hasMatchForCategory) {
        typeInput.style.display = '';
        if (categoryLabel) categoryLabel.style.display = '';
        availableTypeTagInputs.push(typeInput);
      } else {
        typeInput.checked = false;
        typeInput.style.display = 'none';
        if (categoryLabel) categoryLabel.style.display = 'none';
      }
    }

    if (availableTypeTagInputs.length > 0 && document.querySelectorAll('input.type-tag:checked').length === 0) {
      availableTypeTagInputs[0].checked = true;
    }

    var checkedTypes = document.querySelectorAll('input.type-tag:checked');
    for (var c = 0; c < checkedTypes.length; c++) {
      tagTypeArray = tagTypeArray.concat(checkedTypes[c].value.split(','));
    }

    return { animal: tagAnimalArray, type: tagTypeArray };
  }

  function productMatchesFilters(product, filters) {
    var productTagsArray = (product.getAttribute('data-abonnement-product-tag') || '').split(',');
    var matchesAnimal = productTagsArray.some(function (r) {
      return filters.animal.indexOf(r) !== -1;
    });
    if (filters.type.length > 0) {
      var matchesType = productTagsArray.some(function (r) {
        return filters.type.indexOf(r) !== -1;
      });
      return matchesAnimal && matchesType;
    }
    return matchesAnimal;
  }

  function applySubscriptionProductFilters() {
    var filters = getActiveFilterTags();

    var mobileTitle = document.querySelector('.abonnement-tags__title.mobile-only');
    if (mobileTitle) {
      var checkedCount = document.querySelectorAll('.abonnement-type-tags input:checked').length;
      mobileTitle.innerHTML =
        checkedCount > 0 ? 'catégories (' + checkedCount + ')' : 'Choisir une catégorie';
    }

    var allProducts = document.querySelectorAll('.abonnement-product');
    for (var p = 0; p < allProducts.length; p++) {
      var product = allProducts[p];
      var show = productMatchesFilters(product, filters);
      product.classList.toggle('active', show);
      product.classList.remove('is-crossfading-out', 'is-crossfading-in');
    }
  }

  function bindFilterAnimations() {
    var tags = document.querySelector('.abonnement-tags--subscription .abonnement-tags__container');
    var grid = document.querySelector('.subscription-products__grid');
    if (!tags || !grid) return;

    var busy = false;
    var queued = false;
    var ANIM_MS = 420;
    var STAGGER_BASE = 40;
    var STAGGER_STEP = 50;

    function finishBusy() {
      busy = false;
      if (queued) {
        queued = false;
        crossfade();
      }
    }

    function crossfade() {
      if (busy) {
        queued = true;
        return;
      }
      busy = true;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('.subscription-product'));
      var filters = getActiveFilterTags();

      var leaving = [];
      var entering = [];

      cards.forEach(function (card) {
        var willShow = productMatchesFilters(card, filters);
        var isShown = card.classList.contains('active');
        if (isShown && !willShow) leaving.push(card);
        if (!isShown && willShow) entering.push(card);
      });

      if (!leaving.length && !entering.length) {
        applySubscriptionProductFilters();
        finishBusy();
        return;
      }

      // Match account add-flow: swap instantly, then fade-up entering cards with stagger
      applySubscriptionProductFilters();
      window.dispatchEvent(new Event('resize'));

      if (!entering.length) {
        finishBusy();
        return;
      }

      var maxDelay = STAGGER_BASE + Math.max(0, entering.length - 1) * STAGGER_STEP;

      entering.forEach(function (card, index) {
        if (!card.classList.contains('active')) return;
        card.style.setProperty('--sub-anim-delay', STAGGER_BASE + index * STAGGER_STEP + 'ms');
        card.classList.add('is-crossfading-in');
      });

      window.setTimeout(function () {
        entering.forEach(function (card) {
          card.classList.remove('is-crossfading-in');
          card.style.removeProperty('--sub-anim-delay');
        });
        finishBusy();
      }, ANIM_MS + maxDelay + 40);
    }

    tags.addEventListener(
      'change',
      function (e) {
        e.stopPropagation();
        crossfade();
      },
      true
    );
  }

  function init() {
    var section = document.querySelector('[data-subscription-products]');
    if (!section) return;

    bindCartFrequencySync();
    bindFilterAnimations();

    initLockedFrequency().finally(function () {
      var cards = section.querySelectorAll('.subscription-product');
      for (var i = 0; i < cards.length; i++) {
        new SubscriptionProductCard(cards[i]);
      }

      if (typeof window.abonnementProducts === 'function') {
        window.abonnementProducts();
      } else {
        var tagsContainer = document.querySelector('.abonnement-tags__container');
        if (tagsContainer) {
          tagsContainer.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

